<div
    class="spinner-border blue-color"
    style="width: 5rem; height: 5rem"
    role="status"
>
    <span class="sr-only">Loading...</span>
</div>
